import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  createStripePaymentIntent,
  retryStripePaymentIntent,
} from './stripe-payment.api'
import {
  CreateStripePaymentIntentRequestDto,
  CreateStripePaymentIntentResponseDto,
  RetryStripePaymentIntentRequestDto,
} from './dto/invoice-delivery.dto'

interface CreateStripePaymentIntentVariables {
  stripeCustomerId: string
  body: CreateStripePaymentIntentRequestDto
}

export const useCreateStripePaymentIntentMutation = (
  options?: UseMutationOptions<
    CreateStripePaymentIntentResponseDto,
    Error,
    CreateStripePaymentIntentVariables
  >
) =>
  useMutation<
    CreateStripePaymentIntentResponseDto,
    Error,
    CreateStripePaymentIntentVariables
  >({
    ...options,
    mutationFn: ({ stripeCustomerId, body }) =>
      createStripePaymentIntent(stripeCustomerId, body),
  })

interface RetryStripePaymentIntentVariables {
  paymentIntentId: string
  body: RetryStripePaymentIntentRequestDto
}

export const useRetryStripePaymentIntentMutation = (
  options?: UseMutationOptions<
    unknown,
    Error,
    RetryStripePaymentIntentVariables
  >
) =>
  useMutation<unknown, Error, RetryStripePaymentIntentVariables>({
    ...options,
    mutationFn: ({ paymentIntentId, body }) =>
      retryStripePaymentIntent(paymentIntentId, body),
  })
